import React, { useEffect } from "react";
import { Flex } from "rebass/styled-components";
import { FaYoutube } from "react-icons/fa";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { SettingsContainer } from "../../components/molecules/settingsContainer";
import { Body } from "../../components/text";
import { DividerAlt } from "../../components/atoms/dividerAlt";
import { Button } from "../../components/atoms/form/button";
import { ReactComponent as TikTok } from "../../assets/images/misc/tikTok.svg";
import { useFetch } from "../../hooks";
import { useGetUser } from "../../userStore";
import { YoutubeLicense } from "./accountSections/youtubeLicense";
import { useIsDesktopApp } from "../../MVVM/Hooks/useIsDesktopApp";
import { LinkedAccounts } from "../../MVVM/Views/ProfileSettings/LinkedAccounts";
import { useHistory } from "react-router-dom";

const StyledSpan = styled(Body)`
  font-weight: 00;
  color: ${(props) => props.theme.colors.error};
`;

const StyledBox = styled(Flex)`
  background-color: ${(props) => props.theme.colors.ned};
  padding: 20px;
  border-radius: 10px;
`;

const IconWrapper = styled(Flex)`
  position: relative;
  padding: 8px;
  background: #ffffff;
  border-radius: 50%;
`;

const StyledYoutubeIcon = styled(FaYoutube)`
  position: relative;
  color: #ff0000;
  min-height: 30px;
  height: 30px;
  width: auto;
  flex-shrink: 0;
`;

function YouTubeSocialSharing() {
  const { query, fetch } = useFetch(undefined, true);
  const user = useGetUser();
  const { isDesktop } = useIsDesktopApp();
  const history = useHistory();
  useEffect(() => {
    if (query.status === "success") {
      analytics.track("Try to link Google");
      if (isDesktop) {
        try {
          window.parent.postMessage(
            {
              type: "openLink",
              link: query.data.url,
            },
            "*",
          );
          return;
        } catch (e) {
          console.log(e);
        }
      }

      window.location.href = query.data.url;
    }
    // eslint-disable-next-line
  }, [query.status, query.data]);

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Flex alignItems="center">
        <IconWrapper>
          <StyledYoutubeIcon />
        </IconWrapper>
        <Flex mr={10} ml={3}>
          YouTube
        </Flex>
      </Flex>
      <Button
        alignItems="center"
        size="small"
        flex
        classification={user.google ? "roundedSecondary" : undefined}
        onClick={() => {
          history.push(
            "/authenticate/google?referrer=CONNECTED_ACCOUNTS&flow=link",
          );
        }}
      >
        {user?.google?.active ? "ReSync" : "Connect"}
      </Button>
    </Flex>
  );
}

function TikTokSocialSharing() {
  const { t } = useTranslation("translation", {
    keyPrefix: "account.publish",
  });
  const { query, fetch } = useFetch(undefined, true);
  const user = useGetUser();

  useEffect(() => {
    if (query.status === "success") {
      analytics.track("Try to link Google");
      window.location.href = query.data.url;
    }
  }, [query.status, query.data]);

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center">
        <Flex alignItems="center">
          <IconWrapper bg="inherit">
            <TikTok
              style={{
                height: "30px",
                width: "30px",
                position: "relative",
              }}
            />
          </IconWrapper>
          <Flex mr={10} ml={3}>
            TikTok
          </Flex>
        </Flex>
        <Button
          alignItems="center"
          size="small"
          flex
          target="_blank"
          href={`https://open-api.tiktok.com/platform/oauth/connect?client_key=awo8h6fk5xb1mfgd&scope=user.info.basic,video.upload&redirect_uri=${process.env.REACT_APP_BASE_URL}/oauth/tiktok`}
          classification={user.tiktok ? "roundedSecondary" : undefined}
          onClick={() => {}}
        >
          {user.tiktok?.hasUploadScope ? "ReSync" : "Connect"}
        </Button>
      </Flex>
      <StyledBox mt={4}>
        <Body color="chalk">
          <StyledSpan mb={2} color="error">
            Note*
          </StyledSpan>{" "}
          {t("tiktokNote")}
        </Body>{" "}
      </StyledBox>
    </>
  );
}

export default function ConnectedAccounts() {
  const { t } = useTranslation("translation", {
    keyPrefix: "account.publish",
  });
  // const canPublishClip = useCanPublishClip();

  return (
    <>
      <LinkedAccounts />
      <SettingsContainer title={t("publishHeader")} mb={6}>
        <DividerAlt></DividerAlt>
        <Flex
          mb={6}
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Body color="chalk">{t("publishBody")}</Body>
        </Flex>
        <YouTubeSocialSharing />
      </SettingsContainer>
      <YoutubeLicense />
    </>
  );
}
